<template>
  <!-- XOL-586 (Delta 4): the label / value facts of an information dialog ("Triggered", "Step",
       "Who", "When"), as a two-column definition list; one column on a phone. Presentational. -->
  <dl class="info-meta" :class="{ 'is-narrow': narrow }">
    <template v-for="row in rows">
      <dt :key="'k-' + row.key">{{row.label}}</dt>
      <dd :key="'v-' + row.key">{{row.value}}</dd>
    </template>
  </dl>
</template>

<script>
export default {
  name: 'info-meta-list',

  props: {
    // [{ key, label, value }]
    rows: {
      type: Array,
      default: function () { return [] }
    },

    // The phone layout: label above value.
    narrow: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.info-meta { display: grid; grid-template-columns: 96px minmax(0, 1fr); gap: 6px 12px; margin: 0 0 12px; font-size: 13px; line-height: 20px; }
.info-meta dt { color: #909399; }
.info-meta dd { margin: 0; color: #303133; word-break: break-word; }
.info-meta.is-narrow { grid-template-columns: 1fr; gap: 0; }
.info-meta.is-narrow dt:not(:first-child) { margin-top: 8px; }
</style>
